import type { IconData } from '@stacksjs/iconify-core'

export const calendarCheck: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 96h-88V40h-32v56H160V40h-32v56H40a24.03 24.03 0 0 0-24 24v336a24.03 24.03 0 0 0 24 24h432a24.03 24.03 0 0 0 24-24V120a24.03 24.03 0 0 0-24-24m-8 352H48V128h80v40h32v-40h192v40h32v-40h80Z\"/><path fill=\"currentColor\" d=\"m243.397 313.373l-54.385-54.385l-22.627 22.628l77.012 77.011l125.615-125.615l-22.628-22.627z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default calendarCheck
